export default "__VITE_ASSET__51a8613a__"